import {blobToBase64, exportSceneToGLB, exportSceneToUSDZ} from "../../../../../helpers/sqft3dArSceneHelper";
import { generateQRCode } from "../../../../../helpers/sqft3dArHelper";
import SqftJsonApi from "../../../../../api/sqftJsonApi";
import {DEVICE_TYPE} from "../../../../../helpers/sqftMobileHelper";

class SceneExporter {
  constructor(scene) {
    this.scene = scene; // THREE.Scene, который нужно экспортировать
  }

  async exportToGLB() {
    if (!this.scene) throw new Error("Scene is not defined.");
    return await exportSceneToGLB(this.scene, false);
  }

  async exportToUSDZ() {
    if (!this.scene) throw new Error("Scene is not defined.");
    return await exportSceneToUSDZ(this.scene, false);
  }

  async saveFiles(deviceType = DEVICE_TYPE.Desktop) {
    try {
      const sceneFiles = [];

      if (deviceType === DEVICE_TYPE.iOS || deviceType === DEVICE_TYPE.Desktop  || deviceType === DEVICE_TYPE.unknown) {
        const usdzBlob = await this.exportToUSDZ();
        const usdzBase64 = await blobToBase64(usdzBlob);
        sceneFiles.push({ fileExtension: "usdz", base64FileContents: usdzBase64 });
      }

      if (deviceType === DEVICE_TYPE.Android || deviceType === DEVICE_TYPE.Desktop || deviceType === DEVICE_TYPE.unknown) {
        const glbBlob = await this.exportToGLB();
        const glbBase64 = await blobToBase64(glbBlob);
        sceneFiles.push({ fileExtension: "glb", base64FileContents: glbBase64 });
      }

      const savedFiles = await SqftJsonApi.saveFiles(sceneFiles);
      console.log("Saved sceneFiles:", savedFiles);

      return savedFiles;
    } catch (error) {
      console.error("Error saving files:", error);
      throw error;
    }
  }

  async generateDynamicLink(sceneFiles) {
    const encodedLinks = encodeURIComponent(JSON.stringify(sceneFiles.map(file => file.url)));
    const dynamicLink = `${window.location.origin}/kitchen/#/cabinets-ar/${encodedLinks}`;

    console.log("Generated Link:", dynamicLink);
    return dynamicLink;
  }

  async generateQRCode(sceneFiles) {
    const pageUrl = await this.generateDynamicLink(sceneFiles);

    return await generateQRCode(pageUrl);
  }
}

export default SceneExporter;
